module.exports = __webpack_public_path__ + "static/media/sax-hot.d7256f79.svg";